import { Auth, Token } from '../module/public/auth/entity/auth.model';
import { mConstants } from './constants';

export function getToken(): Token | undefined {
  const tokenString = localStorage.getItem(mConstants.TOKEN_KEY);

  if (tokenString && tokenString !== null) {
    return JSON.parse(tokenString);
  }

  return undefined;
}

function setToken(token: Token) {
  localStorage.setItem(mConstants.TOKEN_KEY, JSON.stringify(token));
}

function getUser(): Auth | undefined {
  const userString = localStorage.getItem(mConstants.USER_KEY);

  if (userString !== null) {
    return JSON.parse(userString);
  }

  return undefined;
}

function setUser(user: any) {
  localStorage.setItem(mConstants.USER_KEY, JSON.stringify(user));
}

function clear() {
  localStorage.clear();
}

const storeService = {
  getToken,
  setToken,
  getUser,
  setUser,
  clear,
};

export default storeService;
